import React from 'react';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { AppContext } from '@edx/frontend-platform/react';
import { getConfig } from '@edx/frontend-platform';

import {
  footerLogo, footerLinks, storeLinks,
} from '@edx/brand'; // eslint-disable-line import/no-unresolved
import NavLinks from './NavLinks';
import StoreLinks from './StoreLinks';
import messages from './Footer.messages';

class SiteFooter extends React.PureComponent {
  render() {
    const { intl } = this.props;

    return (
      <footer
        role="contentinfo"
        className="footer"
      >
        <div className="holder">

          <div className="footer-holder">
            <div className="footer-logo">
              <a href={`${getConfig().LMS_BASE_URL}/`}>
                <img
                  src={footerLogo}
                  alt={intl.formatMessage(messages['footer.logo.altText'])}
                />
              </a>
            </div>
            <StoreLinks storeLinks={storeLinks} />
            <NavLinks footerLinks={footerLinks} />
          </div>
        </div>
      </footer>
    );
  }
}

SiteFooter.contextType = AppContext;

SiteFooter.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(SiteFooter);
